<template>
  <div :class="fclass" class="ftdiv twhite">
    <div class="htmldiv tdiv pt15 pb15">
      <img class="dinline-block vcenter pr20" src="../../assets/images/index_01_02.png" @click="$router.push('/')" />
      <div class="dinline-block txt vcenter pl25 pt10 pb10 pr20">
        <div class="mb10 dflex">
          <span class="tc14 mr10" style="flex: 0 0 auto;">联系电话：</span>
          <div style="flex: 1">
            <span class="mr25 ms" style="width: 40%">学历招生：0576-88656392、88665675</span>
            <span class="mr25 ms" style="width: 40%">技能鉴定：0576-88653911</span><br/>
            <span class="mr25 ms" style="width: 40%">社会培训：0576-88663391</span>
            <span class="mr25 ms" style="width: 40%">中职教师：0576-88669918</span><br/>
            <span class="mr25 ms">监督投诉电话：0576-88656023</span>
          </div>
        </div>
        <div class="mb15 dflex">
          <span class="tc14 mr10">联系地址：</span>
          <div>浙江省台州市学院路788号</div>
         </div>
        <div class="tc14">
          Copyright © 2020版权所有 台州职业技术学院继续教育学院 All rights&nbsp;reserved&nbsp;&nbsp;
          <a href="https://beian.miit.gov.cn/" target="_blank" class="tc14">浙ICP备11031232号-9</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "bottom",
      props: {
        fclass: {
          default: 'bg-m'
        }
      },
    }
</script>

<style scoped>
  .ftdiv a{color: #fff;}
  .ftdiv a:hover{text-decoration: underline;}
  .ftdiv .ms{line-height: 1.8;word-wrap: normal;word-break: keep-all;display: inline-block;}
  .ftdiv .txt{line-height: 1.5;width: 900px;}
  .ftdiv.bg-m a{color: #c6d2e1;}
  .ftdiv.bg-m .cydiv a{color: #8e9fc2;}
  .ftdiv.bg-m .txt{border-left: 1px solid #1d4e8d;}
  .ftdiv.bg-m .tc14{color: #d0def0;}

  .ftdiv.bg-g a:hover{color: #bbd9bb;}
  .ftdiv.bg-g .txt{border-left: 1px solid #7ca87c;}
  .ftdiv.bg-g .tc14{color: #bbd9bb;}

  .ftdiv.bg-c a:hover{color: #e8ddcd;}
  .ftdiv.bg-c .tc14{color: #e8ddcd;}
  .ftdiv.bg-c .txt{border-left: 1px solid #c58f45;}

  .ftdiv.bg-b a:hover{color: #e8ddcd;}
  .ftdiv.bg-b .tc14{color: #e5eff8;}
  .ftdiv.bg-b .txt{border-left: 1px solid #4695e0;}

  .ftdiv.bg-grape a:hover{color: #e8c5df;}
  .ftdiv.bg-grape .tc14{color: #e8c5df;}
  .ftdiv.bg-grape .txt{border-left: 1px solid #773766;}

  .ftdiv.bg-black a:hover{color: #e2e4e4;}
  .ftdiv.bg-black .tc14{color: #e2e4e4;}
  .ftdiv.bg-black .txt{border-left: 1px solid #727070;}

</style>



// WEBPACK FOOTER //
// src/components/index/bottom.vue